import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ContextMenu, ContextMenuButton } from '../../../../_lib/components/ContextMenu';
import { ContentList } from '../../../../_lib/components/ContentList';
import { PageToPageListItem } from './PageToPageListItem';
import { Assignment } from '../PageToPageAssignmentCard';
import IForm from '../../../../types/IForm';
import IUrl from '../../../../types/IUrl';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export type EditableAssignment = {
  assignment: Assignment;
  edit?: IForm;
  delete?: IForm;
  templatedPreview: IUrl;
  pageId: string;
};

type PageToPageListEditViewProps = {
  onEditClick: (form: IForm, url: IUrl, pageId: string) => void;
  onDeleteClick: (form: IForm) => void;
  assignments: EditableAssignment[];
};

export function PageToPageListEditView({ onEditClick, onDeleteClick, assignments }: PageToPageListEditViewProps) {
  const { t } = useSonTranslation('PageToPage');
  return (
    <ContentList modifier="padding">
      {assignments.map(assignment => (
        <PageToPageListItem
          key={assignment.assignment.pageLink.url + assignment.assignment.role}
          assignment={assignment.assignment}
        >
          {(assignment.edit || assignment.delete) && (
            <div className="page-to-page-block__context-menu">
              <ContextMenu
                tooltipPlacement={TooltipPlacement.TOP}
                tooltipText={t('pageToPageEditToolTip', { page: assignment.assignment.pageLink.name })}
              >
                {assignment.edit && (
                  <ContextMenuButton
                    aria-haspopup
                    onClick={() => {
                      if (assignment.edit) {
                        onEditClick(assignment.edit, assignment.templatedPreview, assignment.pageId);
                      }
                    }}
                  >
                    {t('editModal.editConnection')}
                  </ContextMenuButton>
                )}
                {assignment.delete && (
                  <ContextMenuButton
                    aria-haspopup
                    onClick={() => {
                      if (assignment.delete) {
                        onDeleteClick(assignment.delete);
                      }
                    }}
                  >
                    {t('deleteModal.deleteConnection')}
                  </ContextMenuButton>
                )}
              </ContextMenu>
            </div>
          )}
        </PageToPageListItem>
      ))}
    </ContentList>
  );
}
